// extracted by mini-css-extract-plugin
export default {"root":"PlasmicCompanyDescriptionComp_root__zJnKT","slotTargetBrandSummaries":"PlasmicCompanyDescriptionComp_slotTargetBrandSummaries__VLJJY"};